export function executeSharedRequire() {
    const shared = require('./lambda/shared');
    return shared;
}

export const shared = executeSharedRequire();
